import { timezoneMap } from '../schema/timezoneMap.js';

const applyTimezoneToDate = ({ date, timezone }) => {
  // If the timezone is UTC, we don't need to do any formatting.
  if (timezone === 'UTC') {
    return date;
  }

  const intlTimezone = timezoneMap[timezone];
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: intlTimezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
    hour12: false
  });
  const parts = formatter.formatToParts(date);

  const dateParts = {};
  parts.forEach((part) => {
    dateParts[part.type] = part.value;
  });

  const year = Number(dateParts.year);
  const month = Number(dateParts.month);
  const day = Number(dateParts.day);
  let hour = Number(dateParts.hour);
  const minute = Number(dateParts.minute);
  const second = Number(dateParts.second);

  // Some ICU/locale combinations can emit "24" instead of "00" for midnight.
  // Normalize to keep the resulting UTC date valid and serializable.
  if (hour === 24) {
    hour = 0;
  }

  return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
};

export default applyTimezoneToDate;
